module.exports = __webpack_public_path__ + "img/GSB.fbf33c3a.png";